import RestService from '../services/rest';

async function getGeneralParams() {
  return RestService.getAuthenticated('generalParams');
}

async function updateGeneralParams(params, files = {}) {
  const hasFiles = Object.keys(files).length > 0;
  if (hasFiles) {
    const fd = new FormData();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null) {
        fd.append(key, params[key]);
      }
    });
    Object.keys(files).forEach((key) => {
      if (files[key]) {
        fd.append(key, files[key]);
      }
    });
    return RestService.putAuthenticated('panel/generalParams/update', fd, {
      'Content-Type': 'multipart/form-data',
    });
  }
  return RestService.putAuthenticated('panel/generalParams/update', params);
}

export default {
  getGeneralParams,
  updateGeneralParams,
};
